import { fetchAPI } from '@/shared/lib/api/client';

import type { RecentWinItem } from '../model/feedSlice';

export interface RecentWinsResponse {
  items: RecentWinItem[];
}

export const feedApi = {
  async getRecentWins(limit = 5): Promise<RecentWinItem[]> {
    const { data } = await fetchAPI.get<RecentWinsResponse>('/feed/recent-wins', {
      params: { limit },
    });
    return data.items;
  },
};
